<form
  [formGroup]="form"
  (ngSubmit)="onSave()"
  class="flex flex-col">
  <div class="flex flex-col">
    <div
      id="header"
      class="flex w-full justify-between mt-6 border-b border-neutral-300 sticky top-0 bg-white py-4 z-50">
      <span class="text-[18px] font-black">
        <i
          [class.pi]="true"
          [class.pi-file-arrow-up]="true"
          style="font-size: 2rem"></i>
        DESPLEGAR SISTEMA DE IA
      </span>
      <div
        id="buttons"
        class="flex gap-4">
        <app-buttons
          [label]="'Cancelar'"
          (click)="cancel()" />
        <app-buttons
          [label]="'Volver al paso anterior'"
          (click)="backPage()" />
        <app-buttons
          [label]="'Continuar'"
          [disabled]="form.invalid"
          [classes]="'bg-primary-base text-primary-light'"
          (click)="confirm()"
          type="button" />
      </div>
    </div>

    <div class="flex flex-col py-4">
      <span class="font-regular text-[18px]">Paso 2 de 6</span>
      <h1 class="font-bold text-[30px] pb-8">Desplegar sistema de IA</h1>

      <h2 class="font-bold text-[24px] pb-6">Cumplimiento Reglamento de Inteligencia Artificial (RIA)</h2>

      <label
        class="text-[16px]"
        for="usageInstructions">
        Instrucciones de uso
        <span *ngIf="highRiskFieldsRequired()">*</span>
      </label>
      <desy-textarea
        formControlName="usageInstructions"
        placeholder="Identificar la URL donde se puede acceder a las instrucciones de uso del proveedor"
        classes="w-full text-[16px]"
        class="w-full"
        [rows]="3"
        [maxlength]="200"></desy-textarea>
      <ng-container *ngIf="getError(form, 'usageInstructions', formSubmitted()) as error; else usageInstructionsInfo">
        <desy-error-message>
          {{ error }}
        </desy-error-message>
      </ng-container>
      <ng-template #usageInstructionsInfo>
        <span class="text-[14px] text-neutral-dark info-message">Puedes escribir hasta 200 caracteres</span>
      </ng-template>

      <div class="grid grid-cols-2 gap-12">
        <div class="flex flex-col">
          <label
            class="text-[16px] mt-4 block"
            for="humanSupervision">
            Supervisión humana
            <span *ngIf="highRiskFieldsRequired()">*</span>
          </label>
          <span class="text-[14px] text-neutral-dark block">Con CSV</span>
          <desy-input
            id="humanSupervision"
            [classes]="'w-full'"
            [placeholder]="'Supervisor-1, Supervisor-2...'"
            formControlName="humanSupervision"></desy-input>
          <desy-error-message *ngIf="getError(form, 'humanSupervision', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>
      </div>

      <label
        class="text-[16px] mt-2"
        for="inputDataQuality">
        Calidad de datos de entrada
        <span *ngIf="highRiskFieldsRequired()">*</span>
      </label>
      <desy-textarea
        formControlName="inputDataQuality"
        placeholder="CSV del documento o URL de acceso al mismo del documento de medidas de calidad de los datos de entrada"
        classes="w-full text-[16px]"
        class="w-full"
        [rows]="3"
        [maxlength]="200"></desy-textarea>
      <ng-container *ngIf="getError(form, 'inputDataQuality', formSubmitted()) as error; else inputDataQualityInfo">
        <desy-error-message>
          {{ error }}
        </desy-error-message>
      </ng-container>
      <ng-template #inputDataQualityInfo>
        <span class="text-[14px] text-neutral-dark info-message">Puedes escribir hasta 200 caracteres</span>
      </ng-template>

      <label
        class="text-[16px] mt-4"
        for="qualityMonitoring">
        Monitorización continua de la calidad de los datos
        <span *ngIf="highRiskFieldsRequired()">*</span>
      </label>
      <desy-textarea
        formControlName="qualityMonitoring"
        placeholder="Existencia sistema de monitorización para detectar automáticamente cambios o desviaciones en la calidad o distribución de los datos de entrada (Data Drift)"
        classes="w-full text-[16px]"
        class="w-full"
        [rows]="3"
        [maxlength]="500"></desy-textarea>
      <ng-container *ngIf="getError(form, 'qualityMonitoring', formSubmitted()) as error; else qualityMonitoringInfo">
        <desy-error-message>
          {{ error }}
        </desy-error-message>
      </ng-container>
      <ng-template #qualityMonitoringInfo>
        <span class="text-[14px] text-neutral-dark info-message">Puedes escribir hasta 500 caracteres</span>
      </ng-template>

      <label
        class="text-[16px] mt-4"
        for="logRetention">
        Conservación de registros (Logs)
        <span *ngIf="highRiskFieldsRequired()">*</span>
      </label>
      <desy-textarea
        formControlName="logRetention"
        placeholder="Ubicación o URL de acceso a los logs"
        classes="w-full text-[16px]"
        class="w-full"
        [rows]="3"
        [maxlength]="200"></desy-textarea>
      <ng-container *ngIf="getError(form, 'logRetention', formSubmitted()) as error; else logRetentionInfo">
        <desy-error-message>
          {{ error }}
        </desy-error-message>
      </ng-container>
      <ng-template #logRetentionInfo>
        <span class="text-[14px] text-neutral-dark info-message">Puedes escribir hasta 200 caracteres</span>
      </ng-template>

      <label
        class="text-[16px] mt-4"
        for="fria">
        Evaluación de Impacto sobre Derechos Fundamentales (EIDF) (Algunos actores)
        <span *ngIf="highRiskFieldsRequired()">*</span>
      </label>
      <desy-textarea
        formControlName="fria"
        placeholder="CSV del documento o URL de acceso al mismo"
        classes="w-full text-[16px]"
        class="w-full"
        [rows]="3"
        [maxlength]="200"></desy-textarea>
      <ng-container *ngIf="getError(form, 'fria', formSubmitted()) as error; else friaInfo">
        <desy-error-message>
          {{ error }}
        </desy-error-message>
      </ng-container>
      <ng-template #friaInfo>
        <span class="text-[14px] text-neutral-dark info-message">Puedes escribir hasta 200 caracteres</span>
      </ng-template>

      <label
        class="text-[16px] mt-4"
        for="dpia">
        EIPD
        <span *ngIf="highRiskFieldsRequired()">*</span>
      </label>
      <desy-textarea
        formControlName="dpia"
        placeholder="CSV del documento o URL de acceso al mismo"
        classes="w-full text-[16px]"
        class="w-full"
        [rows]="3"
        [maxlength]="200"></desy-textarea>
      <ng-container *ngIf="getError(form, 'dpia', formSubmitted()) as error; else dpiaInfo">
        <desy-error-message>
          {{ error }}
        </desy-error-message>
      </ng-container>
      <ng-template #dpiaInfo>
        <span class="text-[14px] text-neutral-dark info-message">Puedes escribir hasta 200 caracteres</span>
      </ng-template>

      <div class="grid grid-cols-2 items-end mt-4">
        <div class="mr-6 flex flex-col">
          <desy-select
            formControlName="naturalPersonInteraction"
            classes="min-w-full">
            <desy-label>Interacción directa con personas físicas*</desy-label>
            <desy-option
              [disabled]="true"
              [selected]="true"
              [hidden]="true">
              Selecciona si hay interacción directa
            </desy-option>
            <desy-option
              *ngFor="let item of binaryOptions"
              [id]="item.label"
              [value]="item.value">
              {{ item.label }}
            </desy-option>
          </desy-select>
          <desy-error-message *ngIf="getError(form, 'naturalPersonInteraction', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>

        <div class="ml-6 flex flex-col">
          <desy-select
            formControlName="contentGeneration"
            classes="min-w-full">
            <desy-label>Generación de contenidos sintéticos (audio, imagen, vídeo o texto)*</desy-label>
            <desy-option
              [disabled]="true"
              [selected]="true"
              [hidden]="true">
              Selecciona si hay generación de contenidos
            </desy-option>
            <desy-option
              *ngFor="let item of binaryOptions"
              [id]="item.label"
              [value]="item.value">
              {{ item.label }}
            </desy-option>
          </desy-select>
          <desy-error-message *ngIf="getError(form, 'contentGeneration', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>

        <div class="mr-6 flex flex-col">
          <desy-select
            formControlName="biometricsEmotions"
            classes="min-w-full">
            <desy-label>Reconocimiento de emociones o categorización biométrica*</desy-label>
            <desy-option
              [disabled]="true"
              [selected]="true"
              [hidden]="true">
              Selecciona si hay reconocimiento
            </desy-option>
            <desy-option
              *ngFor="let item of binaryOptions"
              [id]="item.label"
              [value]="item.value">
              {{ item.label }}
            </desy-option>
          </desy-select>
          <desy-error-message *ngIf="getError(form, 'biometricsEmotions', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>

        <div class="ml-6 flex flex-col">
          <desy-select
            formControlName="publicInterestText"
            classes="min-w-full">
            <desy-label>
              Generación o manipulación de texto con el fin de informar al usuario sobre asuntos de interés público*
            </desy-label>
            <desy-option
              [disabled]="true"
              [selected]="true"
              [hidden]="true">
              Selecciona si hay generación o manipulación de texto
            </desy-option>
            <desy-option
              *ngFor="let item of binaryOptions"
              [id]="item.label"
              [value]="item.value">
              {{ item.label }}
            </desy-option>
          </desy-select>
          <desy-error-message *ngIf="getError(form, 'publicInterestText', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>
      </div>

      <label
        class="text-[16px] mt-4"
        for="dpia">
        <span *ngIf="userInfoRequired()">
          Información sobre uso IA y medidas aplicadas para garantizar transparencia*
        </span>
        <span *ngIf="!userInfoRequired()">
          Información sobre uso IA y medidas aplicadas para garantizar transparencia
        </span>
      </label>
      <desy-textarea
        formControlName="userInformation"
        placeholder="Describir cómo se ha informado a las personas físicas sobre el funcionamiento del sistema y las medidas aplicadas"
        classes="w-full text-[16px]"
        class="w-full"
        [rows]="3"
        [maxlength]="500"></desy-textarea>
      <ng-container *ngIf="getError(form, 'userInformation', formSubmitted()) as error; else userInformationInfo">
        <desy-error-message>
          {{ error }}
        </desy-error-message>
      </ng-container>
      <ng-template #userInformationInfo>
        <span class="text-[14px] text-neutral-dark info-message">Puedes escribir hasta 500 caracteres</span>
      </ng-template>
    </div>
  </div>
</form>
